import { render, staticRenderFns } from "./StandingsRoundDetailsSection.vue?vue&type=template&id=12fecf00&scoped=true"
import script from "./StandingsRoundDetailsSection.vue?vue&type=script&lang=ts"
export * from "./StandingsRoundDetailsSection.vue?vue&type=script&lang=ts"
import style0 from "./StandingsRoundDetailsSection.vue?vue&type=style&index=0&id=12fecf00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fecf00",
  null
  
)

export default component.exports